import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: '[app-dispatcher-report]',
    templateUrl: './dispatcher-report.component.html',
    styleUrls: ['./dispatcher-report.component.css'],
    standalone: false
})
export class DispatcherReportComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DispatcherReport" }));
  }
}
